import { useParams } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Download, CheckCircle, Loader2, Clock } from 'lucide-react'
import { useDescargaInfo } from '../../hooks/useQrCodigo'
import { getDescargaUrl } from '../../api/qr-codigo'

export function DescargaPage() {
  const { token } = useParams<{ token: string }>()
  const { data: info, isLoading, isError } = useDescargaInfo(token)

  const handleDownload = () => {
    if (token) {
      window.open(getDescargaUrl(token), '_blank')
    }
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-teal-500" />
      </div>
    )
  }

  if (isError) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <Card className="max-w-md w-full">
          <CardContent className="p-6 text-center space-y-4">
            <Clock className="h-12 w-12 text-amber-500 mx-auto" />
            <h2 className="text-xl font-bold">Enlace expirado</h2>
            <p className="text-muted-foreground text-sm">
              El enlace de descarga ha expirado o no es válido. Los enlaces tienen una validez de 24 horas.
            </p>
          </CardContent>
        </Card>
      </div>
    )
  }

  const horasRestantes = info ? Math.floor(info.expira_en / 3600) : 0
  const minutosRestantes = info ? Math.floor((info.expira_en % 3600) / 60) : 0

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white dark:from-gray-900 dark:to-gray-950 flex items-center justify-center p-4">
      <Card className="max-w-md w-full border-0 shadow-lg">
        <CardContent className="p-8 text-center space-y-6">
          <div className="rounded-full bg-green-100 dark:bg-green-900/30 p-4 w-fit mx-auto">
            <CheckCircle className="h-12 w-12 text-green-600" />
          </div>

          <div>
            <h2 className="text-xl font-bold">¡Código canjeado exitosamente!</h2>
            {info && (
              <p className="text-muted-foreground text-sm mt-2">
                {info.libro_nombre}
              </p>
            )}
          </div>

          {info?.imagen_portada_url && (
            <img
              src={info.imagen_portada_url}
              alt={info.libro_nombre}
              className="w-32 h-44 object-cover rounded-md mx-auto shadow-md"
            />
          )}

          <Button
            className="w-full bg-green-700 hover:bg-green-800 text-white h-12"
            onClick={handleDownload}
          >
            <Download className="mr-2 h-5 w-5" /> Descargar archivo
          </Button>

          <div className="bg-amber-50 dark:bg-amber-900/20 rounded-md p-3 text-sm text-amber-700 dark:text-amber-300">
            <Clock className="h-4 w-4 inline mr-1" />
            Este enlace expira en {horasRestantes}h {minutosRestantes}m
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
